import { useEffect, useState } from "react";

export default function ScrollTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 w-12 h-12 flex items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-sm cursor-pointer hover:bg-primary-600 hover:-translate-y-1 transition-all"
    >
      <i className="ri-arrow-up-line text-xl"></i>
    </button>
  );
}